import React, { useRef, useState, useEffect } from "react";
import MainLayout from "../../Layouts/Main_Layout";
import Header from "../../Header/header";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import IsiFrame from '../../ISI/Isi-frame';
import Footer from "../../Footer/Footer";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function () {
    const navigate = useNavigate();
    const myRef = useRef(null)
    const [show, setShow] = useState(true)
    const executeScroll = () => {
        myRef.current.scrollIntoView();
        setShow(true)
    }

    useEffect(() => {
        const calculateOffset = () => {
            const componentElement = myRef.current;

            if (myRef) {
            const offsetTop = componentElement.offsetTop;
            function handleScroll() {
                if (window.innerHeight + window.scrollY > offsetTop) {
                setShow(false);
                }
                else (
                setShow(true)
                )
            }
            window.addEventListener("scroll", handleScroll);
            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
            }
        };
        calculateOffset();
        window.addEventListener('resize', calculateOffset)
        return () => { window.removeEventListener('resize', calculateOffset) };
    }, []);

    return (
        <MainLayout>
            <div id='thankyou-page'>
                <Helmet>
                    <title>
                    Thank You For Registering!
                    </title>
                </Helmet>
                <Header />
                <HeaderMenu>
                    <div className='thankyou-menu-padding'>
                    </div>
                </HeaderMenu>
                <div className="brush-style">
                </div>
                <div className='thankyou'>
                    <h1>Thank you</h1>
                    <p>You're now registered to receive updates.</p>
                    <button onClick={() => navigate('/')}>Go to Home Page</button>
                    <div className='thankyou-contact'>
                        Have questions? <br /> Contact us at <b className='thankyou-contact-number'>1-833-INBRIJA</b>
                    </div>
                </div>
                <div ref={myRef}><Isi /></div>
                {show ? <IsiFrame onClick={executeScroll} /> : ''}
                <Footer code="12/23 INB13467" year="2023"
                twitterCode="https://twitter.com/intent/tweet?text=Learn%20more%20about%20INBRIJA.%20INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more.%20https://www.inbrija.com"
                facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2F&title=Learn%20more%20about%20INBRIJA&description=INBRIJA%20is%20inhaled%20levodopa.%20Ask%20your%20doctor%20to%20learn%20more." />
            </div>
        </MainLayout>
    )
}